import React from 'react';
import { ShieldCheck, FlaskConical, UserCheck, Sparkles } from 'lucide-react';

const TRUST_PILLARS = [
  {
    icon: ShieldCheck,
    title: 'Clinically Informed',
    description:
      'Every program is built on rehabilitation, sports science and longevity research — not trends.',
  },
  {
    icon: FlaskConical,
    title: 'Evidence-Based Protocols',
    description:
      'Structured assessment, measurable outcomes and progressive coaching — applied with rigour.',
  },
  {
    icon: UserCheck,
    title: 'Personalised, Always',
    description:
      'Pathways are matched to your capability score, goals and history — never one-size-fits-all.',
  },
  {
    icon: Sparkles,
    title: 'Designed for Lifelong Capability',
    description:
      'From rebuilding mobility to extending healthspan — every protocol compounds for life.',
  },
];

const TrustSection = () => {
  return (
    <section
      id="trust"
      className="section-padding bg-section"
      data-testid="trust-section"
    >
      <div className="container">
        <div className="text-center mb-12 max-w-3xl mx-auto">
          <h2 className="section-title" data-testid="trust-section-title">
            Why People Choose Zeeva
          </h2>
          <p
            className="section-subtitle"
            data-testid="trust-section-subtitle"
            style={{ fontWeight: 600 }}
          >
            A premium Human Capability practice — engineered for healthspan,
            longevity, mobility, rehabilitation and performance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {TRUST_PILLARS.map((pillar) => {
            const Icon = pillar.icon;
            return (
              <div
                key={`trust-${pillar.title}`}
                className="reason-card"
                data-testid={`trust-pillar-${pillar.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div
                  className="service-icon"
                  style={{ marginBottom: '1rem' }}
                  aria-hidden="true"
                >
                  <Icon size={28} />
                </div>
                <h3 className="reason-title">{pillar.title}</h3>
                <p className="reason-description">{pillar.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
